import { Card, CardContent } from "@/components/ui/card.tsx";

interface MetricCardProps {
    label: string
    value: string
    subtext?: string
    color?: string
}

export default function MetricCard({label, value, subtext, color}: MetricCardProps) {
    return (
        <Card>
            <CardContent>
                <div className="text-xs text-slate-500 dark:text-slate-400">{label}</div>

                <div className={`text-lg font-semibold ${color || 'text-slate-900 dark:text-white'}`}>
                    {value}
                </div>
                {subtext && (
                    <div className="text-xs text-slate-500 dark:text-slate-400">
                        {subtext}
                    </div>
                )}
            </CardContent>

        </Card>
    )
}